/**
 * API клиент для работы с заказами (клиентская часть).
 */
import axios from 'axios';

// Base URL для API
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/orders/api';

const client = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // Отключаем отправку credentials (cookies), так как endpoints exempt от CSRF
  withCredentials: false,
});

/**
 * Получить заказ по UID.
 * @param {string} uid - UID заказа
 * @returns {Promise<Object>} Данные заказа
 */
export async function getOrderByUid(uid) {
  const response = await client.get(`/public/${uid}/`);
  return response.data;
}

/**
 * Отменить заказ с возвратом средств (для клиента).
 * @param {string} uid - UID заказа
 * @param {string} reason - Причина отмены
 * @returns {Promise<Object>} Обновлённый заказ
 */
export async function cancelOrder(uid, reason = '') {
  const response = await client.post(`/public/${uid}/cancel/`, {
    reason,
    role: 'client',
  });
  return response.data;
}

export default client;
